import { createRouter, createWebHistory } from 'vue-router';
import platformModule from '../modules/platform/platform.module';

// The platform SPA shares the bundle with the CPO app but runs its own router
// with only the /platform/* routes. Auth is enforced upstream: the platform
// bootstrap inits keycloak-js with onLoad:'login-required', so the app only
// mounts once the hive-platform realm has authenticated the user (ADR-007).
export function createPlatformRouter() {
    const router = createRouter({
        history: createWebHistory('/'),
        routes: [],
    });

    platformModule.routes.items.forEach((route) => router.addRoute(route));

    return router;
}

export function setupPlatformRouter(router) {
    router.afterEach((to) => {
        document.title = to.meta?.title
            ? `${to.meta.title} — Hive Platform`
            : 'Hive Platform';
    });
}
